import React from 'react';
import PropTypes from 'prop-types';

class FieldSet extends React.Component {
  render() {
    const { title, children, actionButton } = this.props;

    return (
      <div>
        {
        title && (
          <div className="field-set">
            <h3>{ title }</h3>
            <hr className="field-set-line" />
            {actionButton && <span className="ml-2">{actionButton}</span>}
          </div>
        )}
        <div className="field-set-slot">
          { children }
        </div>
      </div>
    );
  }
}

FieldSet.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  actionButton: PropTypes.node,
};

FieldSet.defaultProps = {
  children: null,
  actionButton: null,
};

export default FieldSet;
